import { siteName, testimonials } from '@/mocks/chigua';

const PRINCIPLES = [
  { icon: 'ri-eye-2-line', title: '先理脉络', desc: '每条热点都先交代来龙去脉，把时间线与关键节点摆清楚，再谈讨论与观点。' },
  { icon: 'ri-scales-3-line', title: '不抢先定调', desc: '存在多方说法的事件并列呈现，事实与主观评论明确区分，让读者自己下判断。' },
  { icon: 'ri-focus-2-line', title: '跟着热度走', desc: '把正在发酵与反复被顶的话题按热度与时间排好，你在首页就能掌握节奏。' },
  { icon: 'ri-sun-line', title: '温和理性', desc: '吃瓜不造谣、不引战，用建设性的讨论氛围，把围观变成有意思的交流。' },
];

export default function About() {
  return (
    <section id="about" className="scroll-mt-24 bg-foreground-950 text-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-14">
          {/* intro */}
          <div>
            <p className="flex items-center gap-1.5 text-xs font-semibold tracking-widest text-accent-300">
              <i className="ri-team-line"></i> 关于 {siteName}
            </p>
            <h2 className="heading-font mt-2 text-2xl font-extrabold leading-snug md:text-4xl">
              一群把瓜剥好、
              <br className="hidden md:block" />
              摆整齐的互联网常驻用户
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-background-100/85 md:text-base">
              我们相信热点值得被更好地看见。{siteName}
              由编辑部负责筛选全网高热、有讨论价值的事件，由观察组撰写复盘与专题——把散落在各处的今日热点、全网爆点与真实讨论，收拢成一条能顺着读完的信息流。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-background-100/70">
              无论你是通勤路上补课，还是深夜想找人聊聊，都能在这里找到今天最值得跟进的那一条，以及愿意陪你吃瓜的人。
            </p>

            <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-4">
              {[
                { n: '38万+', l: '累计追热点用户' },
                { n: '1200万+', l: '年阅读讨论量' },
                { n: '2600+', l: '整理出镜热点' },
                { n: '7×24', l: '持续滚动更新' },
              ].map((s) => (
                <div key={s.l} className="rounded-lg bg-background-50/5 p-3 text-center">
                  <p className="heading-font text-xl font-extrabold text-accent-300">{s.n}</p>
                  <p className="mt-1 text-[10px] text-background-100/70 md:text-xs">{s.l}</p>
                </div>
              ))}
            </div>
          </div>

          {/* principles */}
          <div>
            <h3 className="heading-font text-base font-bold text-accent-200">我们做内容的原则</h3>
            <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {PRINCIPLES.map((p) => (
                <div key={p.title} className="rounded-lg bg-background-50/5 p-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500/20 text-accent-300">
                    <i className={`${p.icon} text-lg`}></i>
                  </span>
                  <h4 className="mt-3 text-sm font-bold text-background-50">{p.title}</h4>
                  <p className="mt-1 text-xs leading-relaxed text-background-100/75">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* testimonials */}
        <div className="mt-12 border-t border-background-200/10 pt-8">
          <h3 className="heading-font text-center text-lg font-bold text-background-50 md:text-xl">
            吃过瓜的伙伴们怎么说
          </h3>
          <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3">
            {testimonials.map((t) => (
              <figure key={t.id} className="rounded-lg bg-background-50/5 p-5">
                <div className="flex gap-0.5 text-accent-400">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <blockquote className="mt-3 text-xs leading-relaxed text-background-100/85 md:text-sm">
                  “{t.quote}”
                </blockquote>
                <figcaption className="mt-3 flex items-center gap-2">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-500/20 text-accent-300">
                    <i className="ri-user-3-line"></i>
                  </span>
                  <span>
                    <span className="block text-xs font-semibold text-background-50">{t.name}</span>
                    <span className="block text-[10px] text-background-100/60">{t.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}